import React, { useEffect, useState } from 'react';
import { Column, FormatterProps } from 'react-data-grid';
import {
	getDBCPUUtilization,
	getDBCPUUtilizationDate,
	jobSearchCPUUtilization
} from '../../../service/service';
import { databricksurl } from '../../../service/config';

import axios from 'axios';
import { CustomizedDataGrid } from '../../customized_data_grid';
import { Grid } from '@mui/material';
import { useSearchParams } from 'react-router-dom';
import Loader from '../../Loader/loader';
import '../Summary/Summary.scss';
import './ResourceOpt.scss';

interface Row {
	workspace_name: string;
	project_name: string;
	sku: string;
	sector_name: string;
	cluster_name: string;
	job_name: string;
	avg_spark_task_runtime_hrs: string;
	Avg_job_worker_potential_core_hrs: string;
	Avg_job_run_cluster_util_percentile: string;
}

type EllipsisFormatterProps = {
  readonly value?: string | null;
};

function EllipsisFormatter({
  value
}: EllipsisFormatterProps) {
  return (
    <div title={value ?? ''} className="has-ellipsis">
      {value || '--'}
    </div>
  );
}

function createEllipsisFormatter<K extends keyof Row>(field: K) {
  return function Formatter(props: FormatterProps<Row>) {
    return (
      <EllipsisFormatter
        value={props.row[field]}
      />
    );
  };
}

const sectorNameFormatter = createEllipsisFormatter('sector_name');
const workspaceNameFormatter = createEllipsisFormatter('workspace_name');
const clusterNameFormatter = createEllipsisFormatter('cluster_name');
const jobNameFormatter = createEllipsisFormatter('job_name');
const projectNameFormatter = createEllipsisFormatter('project_name');

const CPUUtilization = ({ fromDateTime, sectorFilter, setFromDateTime, dateSelect }: any) => {

	const columns: Array<Column<Row>> = [
			{
				key: 'sector_name',
				name: 'Sector Name',
				formatter: sectorNameFormatter,
				minWidth: 180
			},
			{
				key: 'workspace_name',
				name: 'Workspace',
				formatter: workspaceNameFormatter,
				minWidth: 120,
				width: 250
			},
			{
				key: 'cluster_name',
				name: 'Cluster Name',
				formatter: clusterNameFormatter,
				minWidth: 120,
				width: 200
			},
			{
				key: 'sku',
				name: 'Cluster Type',
				minWidth: 120,
				width: 130
			},
			{
				key: 'job_name',
				name: 'Job Name',
				formatter: jobNameFormatter,
				minWidth: 120,
				width: 250
			},
			{
				key: 'avg_spark_task_runtime_hrs',
				name: 'Avg Spark Runtime Hrs',
				minWidth: 200
			},
			{
				key: 'avg_job_worker_potential_core_hrs',
				name: 'Avg Potential Core Hrs',
				minWidth: 200
			},
			{
				key: 'avg_job_run_cluster_util_percentile',
				name: 'Avg Cluster Utilization',
				minWidth: 200
			},
			{
				key: 'project_name',
				name: 'Project Name',
				formatter: projectNameFormatter,
				minWidth: 120,
				width: 250
			}

		];

	const defaultColumnNames = [
		'Sector Name',
		'Workspace',
		'Cluster Name',
		'Cluster Type',
		'Job Name',
		'Avg Spark Runtime Hrs',
		'Avg Potential Core Hrs',
		'Avg Cluster Utilization',
		'Project Name'
	];

	const [CPUUtilizationList, setCPUUtilizationList] = useState<Row[]>([]);
	const [sortingInfo, setSortingInfo] = useState({ sortBy: 'avg_job_run_cluster_util_percentile', sortDir: 'desc' });
	const [paginationData, setPaginationData] = useState({ totalPages: 0, totalCount: 0 });
	const [page, setPage] = useState(1);
	const [pageSize, setPageSize] = useState(100);
	const [searchDetails, setFilterSearchInfo] = useState([]);
	const [searchParams, setSearchParams] = useSearchParams();
	const [loading, setLoading] = useState(false);
	const [filterInfo, setFilterInfo] = useState([]);
	const [filterData, setFilterData] = useState<Row[]>([]);
	const [error, setError] = useState<string | null>(null);

	const handlePageChange = async (event: any, value: number) => {
	try {

		setLoading(true);
		let nextPage = value.toString(); 
		if(event.target.dataset.testid == "LastPageIcon" || event.target.dataset.testid == "FirstPageIcon"){
			nextPage = value.toString(); 
		}
		else if(event.target.dataset.testid == "NavigateBeforeIcon"){
			nextPage = (Number(page) - 1).toString();
		}
		else if (nextPage === event.target.textContent) { 
			nextPage = event.target.textContent;
		} else {
			nextPage = (Number(page) + 1).toString();
		}
		await DBCPUUtilizationListingFunc(
			Number.parseInt(nextPage),
			pageSize,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			parseFilter(filterInfo),
			sectorFilter
		);
		} catch(error: unknown) {
			setError(error instanceof Error ? error.message : 'Something went wrong'); // Set error state when API call fails
		} finally {
			setLoading(false);
		};
	};

	const handlepageSizeChange = async (event: any) => {
	try {

		setLoading(true);
		await DBCPUUtilizationListingFunc(
			'1',
			event.target.value,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			parseFilter(filterInfo),
			sectorFilter
		)
	   } catch(error: unknown) {
			setError(error instanceof Error ? error.message : 'Something went wrong'); // Set error state when API call fails
		} finally {
			setLoading(false);
		};
	};

	const handleSorting = async (sortingInfo: any) => {
	try {

		setLoading(true);
		await DBCPUUtilizationListingFunc(
			page,
			pageSize,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			parseFilter(filterInfo),
			sectorFilter
		)
		} catch(error: unknown) {
			setError(error instanceof Error ? error.message : 'Something went wrong'); // Set error state when API call fails
		} finally {
			setLoading(false);
		};
	};

	const parseFilter = (filterInfo: any, name?: string) => {
		// Call only filterable columns and reset the filtering in case of wrong/empty column
		const parsedFilter: any = {};
		Object.keys(filterInfo).forEach((key: any) => {
			if (key !== name && filterInfo[key]?.length) {
				parsedFilter[key] = filterInfo[key];
			}
		});
		return parsedFilter;
	};

	const resetSearchParams = () => {
		if (searchParams.has('fromDate')) {
			searchParams.delete('status');
			searchParams.delete('scheduleDate');
			searchParams.delete('fromDate');
			setSearchParams(searchParams);
		}
	};

	const handleFilter = async (filterInfo: any) => {
	try {
		resetSearchParams();
		setFilterInfo(filterInfo);
		setLoading(true);
		await DBCPUUtilizationListingFunc(
			1,
			pageSize,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			parseFilter(filterInfo),
			sectorFilter
		)
		} catch(error: unknown) {
			setError(error instanceof Error ? error.message : 'Something went wrong'); // Set error state when API call fails
		} finally {
			setLoading(false);
		};
	};

	async function jobSearchForDBWorkspaceFunc(searchDetails: any, columnKey: any) {
		const res = await jobSearchCPUUtilization(searchDetails, columnKey, fromDateTime,
			filterInfo,
			sectorFilter);
		if (res.success) {
			setFilterSearchInfo(res.data);
		}
	}

	const handleSearch = (searchDetails: any, columnKey: any) => {
		jobSearchForDBWorkspaceFunc(searchDetails, columnKey);
	};

	// Initial load API call
	async function DBCPUUtilizationListingFunc(
		pageNumber: any,
		size: any,
		sortingInfo: any,
		fromDateTime: any,
		toDateTime: any,
		jobFilterInfo: any,
		sector: any
	) {
		setLoading(true);
		try {
			let storedSectorFilter = localStorage.getItem('d-resource-sector-filter')
			? JSON.parse(localStorage.getItem('d-resource-sector-filter') ?? '')
			: null;
			if (storedSectorFilter) {
				sector = storedSectorFilter;
			}
	
			// Make a call to Databricks
			const databricksresponse = await axios.get(`${databricksurl}`);
		
			console.log('Databricks Call initiated', databricksresponse);
	
			if (databricksresponse?.status) {
				// Fetch the CPU utilization data
				const res = await getDBCPUUtilization(
					pageNumber.toString(),
					size.toString(),
					sortingInfo,
					jobFilterInfo,
					fromDateTime,
					fromDateTime,
					sector
				);
	
				if (res.success) {
					// Format the response data
					const addDollar = res.data.data.map((item: any) => ({
						...item,
						avg_spark_task_runtime_hrs: item.avg_spark_task_runtime_hrs !== null && item.avg_spark_task_runtime_hrs !== undefined
							? `${item.avg_spark_task_runtime_hrs.toFixed(2)}`
							: '--',
						avg_job_worker_potential_core_hrs: item.avg_job_worker_potential_core_hrs !== null && item.avg_job_worker_potential_core_hrs !== undefined
							? `${item.avg_job_worker_potential_core_hrs.toFixed(2)}`
							: '--',
						avg_job_run_cluster_util_percentile: item.avg_job_run_cluster_util_percentile !== null && item.avg_job_run_cluster_util_percentile !== undefined
							? `${item.avg_job_run_cluster_util_percentile.toFixed(2)}`
							: '--',
						project_name: item.project_name !== null && item.project_name !== undefined
							? `${item.project_name}`
							: '--'
					}));
	
					// Update the state with the formatted data
					setCPUUtilizationList(addDollar);
					setPaginationData(res.data.page);
					setFilterData(res.data.filterOptions);
				setFilterInfo(jobFilterInfo);
				setPage(pageNumber);
				setPageSize(size);
				setFromDateTime(localStorage.getItem('processedDate'));
				setSortingInfo(sortingInfo);
					setError(null);
				} else {
					setError('Failed to fetch data');
				}
			} else {
				setError('Cluster Inactive');
			}
		} catch (error: unknown) {
			console.error(error);
			setError('Failed to fetch data');
		} finally {
			setLoading(false);
		}
	}
	

	// User select specific date API call
	async function DBCPUUtilizationListingDateFunc(
		pageNumber: any,
		size: any,
		sortingInfo: any,
		fromDateTime: any,
		toDateTime: any,
		jobFilterInfo: any,
		sector: any
	) {
		setLoading(true);
		try {
			const res = await getDBCPUUtilizationDate(
				pageNumber.toString(),
				size.toString(),
				sortingInfo,
				jobFilterInfo,
				fromDateTime,
				fromDateTime,
				sector
			);
			if (res.success) {
				const addDollar = res.data.data.map((item: any) => {
					return {
						...item,
						avg_spark_task_runtime_hrs: `${
							item.avg_spark_task_runtime_hrs !== null && item.avg_spark_task_runtime_hrs !== undefined
								? `${item.avg_spark_task_runtime_hrs.toFixed(2)}`
								: '--'
						}`,
						avg_job_worker_potential_core_hrs: `${
							item.avg_job_worker_potential_core_hrs !== null && item.avg_job_worker_potential_core_hrs !== undefined
								? `${item.avg_job_worker_potential_core_hrs.toFixed(2)}`
								: '--'
						}`,
						avg_job_run_cluster_util_percentile: `${
							item.avg_job_run_cluster_util_percentile !== null &&
							item.avg_job_run_cluster_util_percentile !== undefined
								? `${item.avg_job_run_cluster_util_percentile.toFixed(2)}`
								: '--'
						}`,

						project_name: `${
							item.project_name !== null && item.project_name !== undefined ? `${item.project_name}` : '--'
						}`
					};
				});
				setCPUUtilizationList(addDollar);
				setPaginationData(res.data.page);
				setFilterData(res.data.filterOptions);
				setFilterInfo(jobFilterInfo);
				setPage(pageNumber);
				setPageSize(size);
				setSortingInfo(sortingInfo);
			} else {
				setError('Failed to fetch data'); // Set the error state if API call fails
			}
		}  catch (error: unknown) {
			console.error(error);
			setError('Failed to fetch data');
		} finally {
			setLoading(false);
		}
		setLoading(false);
	}


	// API
	useEffect(() => {
		setError(null);
		DBCPUUtilizationListingFunc(
			page,
			pageSize,
			sortingInfo,
			fromDateTime,
			fromDateTime,
			[],
			sectorFilter
		);
	}, [sectorFilter]);

	useEffect(() => {
		setError(null);
		if (dateSelect != 0) {
			DBCPUUtilizationListingDateFunc(
				"1",
				pageSize,
				sortingInfo,
				fromDateTime,
				fromDateTime,
				[],
				sectorFilter
			);
		}
	}, [dateSelect]);
	
	let content: React.ReactNode;

	if (error === 'Cluster Inactive') {
	content = (
		<div
		style={{
			color: '#e5e5e5',
			marginLeft: '25%',
			padding: '10px',
			fontWeight: 500,
			gridColumn: '1 / -1'
		}}
		>
		Cluster is Inactive, it will take Max 2mins to start, Please try again later
		</div>
	);
	} else if (error) {
	content = (
		<div
		style={{
			color: '#e5e5e5',
			marginLeft: '25%',
			padding: '10px',
			fontWeight: 500,
			gridColumn: '1 / -1'
		}}
		>
		Error occurred while fetching data. Please try again.
		</div>
	);
	} else if (loading) {
	content = <Loader />;
	} else {
	content = (
		<Grid className="resourceOpt_tabledata">
		<CustomizedDataGrid
			tableColumns={columns}
			tableData={CPUUtilizationList}
			tableType="CPUUtilization"
			defaultColumnNames={defaultColumnNames}
			onSorting={handleSorting}
			currSorting={sortingInfo}
			filterDataOptions={filterData}
			onFilterCheck={handleFilter}
			currFilter={filterInfo}
			searchDataValues={searchDetails}
			onFilterSearch={handleSearch}
			page={page}
			pageSize={pageSize}
			paginationData={paginationData}
			listLength={CPUUtilizationList.length}
			handlepageSizeChange={handlepageSizeChange}
			handlePageChange={handlePageChange}
			isDateRangeFilter={false}
			isDisabled={false}
		/>

		{CPUUtilizationList?.length ? (
			<p className="disclaimer">
			Note: Double hyphens (--) indicate that the field has no data.
			</p>
		) : null}
		</Grid>
	);
	}

return (
  <div className="res-opt-table-wrap">
    <p className="databricks_title">CPU Utilization</p>
    {content}
  </div>
);
};

export default CPUUtilization;
